import PropTypes from "prop-types";
import validator from "validator";

const ViewReasonModal = ({ toggleMethod, response_reason }) => {
  // If the close (x) is clicked
  const close = () => {
    toggleMethod();
  };

  return (
    <div className="container--modal_wrapper">
      <div className="container--modal-dark">
        <div className="container--modal_cancel_application_declined">
          <button
            className="button--modal_cancel_application_declined"
            aria-label="Close modal"
            onClick={close}>
            X
          </button>
        </div>
        <div className="container--inner_modal">
          <h2 className="header header--modal_heading header--modal_confirm">
            Response from team manager
          </h2>
          <div className="form--modal_form">
            <label className="label--form_label" htmlFor="declineReason">
              Why is this applicant not a correct fit?
              <p className="input input--form_input input--form_text_area">
                {validator.unescape(response_reason)}
              </p>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReasonModal;

ViewReasonModal.propTypes = {
  toggleMethod: PropTypes.func,
  response_reason: PropTypes.string,
};
